module.exports = __webpack_public_path__ + "img/logotype-北师大.338973a8.svg";